module.exports = __webpack_public_path__ + "static/media/circle.9f0e5da7.svg";